import React from 'react'
import { TableHeader as Table, TableColHeader } from 'Components/Shared/Table'
import { RadioBox } from 'Components/Shared/Form'

type Props = {
  onSort(name: string): void
  sorting: any
  showRadio?: boolean
  onSelectAll?: () => void
  isSelectAll?: boolean
  showThumbnail?: boolean
}

const ReportHeader: React.FunctionComponent<Props> = props => {
  const {
    showRadio = false,
    onSelectAll = () => {},
    isSelectAll = false,
    showThumbnail = false,
  } = props

  const getRadioBox = () => {
    return (
      <RadioBox
        value={''}
        label={''}
        isCheck={isSelectAll}
        onClick={onSelectAll}
        size={24}
      />
    )
  }
  const spanCondition = showThumbnail ? 4 : 5

  const column = [
    {
      title: 'ลักษณะงานหลัก',
      span: spanCondition,
      key: '',
    },
    {
      title: 'ลักษณะงานรอง',
      span: spanCondition,
      key: '',
    },
    {
      title: 'รายละเอียด',
      span: spanCondition,
      key: '',
    },
    {
      title: 'สถานะ',
      span: 4,
      key: '',
    },
    {
      title: showThumbnail ? 'รูปตัวอย่าง' : '',
      span: showThumbnail ? 4 : 0,
      key: 'thumbnail',
    },
    {
      title: showRadio ? getRadioBox() : '',
      span: 2,
      key: '',
      sort: false,
    },
  ]

  const content = column.map((item: any, index: number) => {
    return (
      <TableColHeader
        key={index}
        span={item.span}
        //onSort={() => onSort(item.key)}
        type=""
        sort={false}
      >
        {item.title}
      </TableColHeader>
    )
  })

  return (
    <Table>
      <TableColHeader span={2} type="" sort={false} isPadding={true}>
        หมุดที่
      </TableColHeader>
      {content}
    </Table>
  )
}

export default ReportHeader
